// import { Directive, Input, ElementRef } from "@angular/core";

// @Directive({
//   selector: "[svgGroup]",
// })
// export class SvgGroupDirective {
//   @Input() height: number;
//   @Input() width: number;

//   constructor(private el: ElementRef) {}

//   ngOnInit() {
//     this.el.nativeElement.setAttribute("transform", `translate(0, 0)`);
//   }
// }




import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[svgHeight]'
})
export class SvgHeightDirective {
  @Input() svgHeight: string;

  constructor(private el: ElementRef<SVGElement>, private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'height', this.svgHeight);
  }
}

@Directive({
  selector: '[svgWidth]'
})
export class SvgWidthDirective {
  @Input() svgWidth: string;

  constructor(private el: ElementRef<SVGElement>, private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'width', this.svgWidth);
  }
}

@Directive({
  selector: '[svgScale]'
})
export class SvgScaleDirective {
  @Input() svgScale: string;

  constructor(private el: ElementRef<SVGElement>, private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'scale', this.svgScale);
  }
}